/// <amd-module name="ExtensionManagement/ManagementHub/PublisherNameComponent" />
import * as React from "react";

import { Icon } from "VSSUI/Icon";

import { IExtensionViewModel } from "./UIContracts";

import * as Resources from "ExtensionManagement/ManagementHub/Resources.ExtManagmentHub";
import { css } from "VSSUI/Util";
import { Tooltip } from "VSSUI/TooltipEx";

interface IPublisherNameComponentProps {
    /**
     * Optional class name to be used.
     */
    className?: string;

    /**
     * Extension being rendered
     */
    extension: IExtensionViewModel;

    /**
     * Optional publisher name text to be used.
     */
    publisherNameText?: string;
}

export class PublisherNameComponent extends React.Component<IPublisherNameComponentProps> {
    public render(): JSX.Element {
        const publisherName: string = this.props.publisherNameText || this.props.extension.publisherName;
        return (
            <Tooltip text={publisherName}>
                <div className={css(this.props.className, "word-break")}>
                    {publisherName}
                    {this.props.extension.isCertifiedPublisher && (
                        <Icon
                            iconName="VerifiedBrandSolid"
                            className="certified-publisher"
                            ariaLabel={Resources.TopPublisher}
                            tooltipProps={{ text: Resources.TopPublisher }}
                        />
                    )}
                </div>
            </Tooltip>
        );
    }
}
